import Translated from "../infrastructure/translation/Translated";
import { LinkButton } from "@digipost/dds-buttons-react";
import styles from "./ManuellRegistreringKnapp.module.less";
import { TranslationKey } from "../infrastructure/translation/translator";

interface ManuellRegistreringKnappProps {
  textKey?: TranslationKey;
  setShowManualSearch: (b: boolean) => void;
}

export function ManuellRegistreringKnapp({
  textKey,
  setShowManualSearch,
}: ManuellRegistreringKnappProps) {
  return (
    <p>
      <Translated textKey={textKey || "virksomhet.velg.not_found"} />
      <LinkButton
        className={styles.manuellRegistrering}
        onClick={() => setShowManualSearch(true)}
      >
        <Translated textKey={"virksomhet.velg.not_found_link"} />
      </LinkButton>
    </p>
  );
}
